import { useState } from 'react'
import { Activity } from 'lucide-react'
import { useJobs } from '../hooks/useJobs'
import { JobDefinicao } from '../tipos/job'
import { TabelaJobs } from '../componentes/TabelaJobs'
import { ModalEditarJob } from '../componentes/ModalEditarJob'
import { ModalHistoricoJob } from '../componentes/ModalHistoricoJob'

export default function PaginaJobs() {
  const { data: jobs = [], isLoading, refetch } = useJobs()
  const [jobEdicao, setJobEdicao] = useState<JobDefinicao | null>(null)
  const [jobHistorico, setJobHistorico] = useState<JobDefinicao | null>(null)

  return (
    <>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Jobs</h1>
          <p className="mt-1 text-sm text-gray-600">
            Configure execução, intervalos e dispare manualmente as rotinas em segundo plano
          </p>
        </div>
      </div>

      {isLoading && (
        <div className="bg-white rounded-xl border border-gray-200 shadow-theme-sm p-8 text-center">
          <div className="loading-spinner mx-auto mb-4" />
          <p className="text-gray-600">Carregando jobs...</p>
        </div>
      )}

      {!isLoading && jobs.length === 0 && (
        <div className="bg-white rounded-xl border border-gray-200 shadow-theme-sm p-8 text-center">
          <Activity className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Nenhum job cadastrado</h3>
          <p className="text-gray-600">Os jobs do sistema aparecem aqui automaticamente.</p>
        </div>
      )}

      {!isLoading && jobs.length > 0 && (
        <TabelaJobs
          jobs={jobs}
          onRefresh={refetch}
          onEditar={setJobEdicao}
          onVerHistorico={setJobHistorico}
        />
      )}

      <ModalEditarJob isOpen={!!jobEdicao} job={jobEdicao} onClose={() => setJobEdicao(null)} />
      <ModalHistoricoJob isOpen={!!jobHistorico} job={jobHistorico} onClose={() => setJobHistorico(null)} />
    </>
  )
}
